module.exports = __webpack_public_path__ + "public/SiteImages/Delete.svg?694fb51d";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/Delete.svg
// module id = 996
// module chunks = 8